import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, mergeProps as _mergeProps, resolveDirective as _resolveDirective, withCtx as _withCtx, withDirectives as _withDirectives, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b2ffbf86"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ml-2" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ml-auto border-1 surface-border border-round surface-100 text-xs p-1 pi pi-angle-down" }, null, -1))
const _hoisted_3 = { class: "ml-2" }
const _hoisted_4 = {
  key: 1,
  class: "ml-auto border-1 surface-border border-round surface-100 text-xs p-1"
}
const _hoisted_5 = { class: "ml-2" }

export function render(_ctx, _cache) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")
  const _component_p_badge = _resolveComponent("p-badge")
  const _component_router_link = _resolveComponent("router-link")
  const _component_p_tiered_menu = _resolveComponent("p-tiered-menu")
  const _directive_ripple = _resolveDirective("ripple")

  return (_ctx.menu.items)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.toggle && _ctx.toggle(...args))),
        "aria-haspopup": "true",
        "aria-controls": "overlay_tmenu"
      }, [
        (Array.isArray(_ctx.menu.icon) && _ctx.menu.icon.length === 2 && _ctx.menu.icon.every(i => typeof i === 'string' && i.trim() !== ''))
          ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
              key: 0,
              icon: _ctx.menu.icon
            }, null, 8, ["icon"]))
          : _createCommentVNode("", true),
        _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.menu.label), 1),
        _hoisted_2,
        _createVNode(_component_p_tiered_menu, {
          ref: "menu",
          id: "overlay_tmenu",
          model: _ctx.menu.items,
          popup: ""
        }, {
          item: _withCtx(({ item, props, hasSubmenu , root}) => [
            _withDirectives((_openBlock(), _createBlock(_component_router_link, _mergeProps({
              to: item.to || '',
              class: "flex align-items-center"
            }, props.action), {
              default: _withCtx(() => [
                (Array.isArray(item.icon) && item.icon.length === 2 && item.icon.every(i => typeof i === 'string' && i.trim() !== ''))
                  ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                      key: 0,
                      icon: item.icon
                    }, null, 8, ["icon"]))
                  : _createCommentVNode("", true),
                _createElementVNode("span", _hoisted_3, [
                  _createTextVNode(_toDisplayString(item.label) + " ", 1),
                  (item.badge)
                    ? (_openBlock(), _createBlock(_component_p_badge, {
                        key: 0,
                        class: "ml-auto",
                        value: item.badge
                      }, null, 8, ["value"]))
                    : _createCommentVNode("", true)
                ]),
                (item.shortcut)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(item.shortcut), 1))
                  : _createCommentVNode("", true),
                hasSubmenu
                  ? (_openBlock(), _createElementBlock("i", {
                      key: 2,
                      class: _normalizeClass(['pi pi-angle-down text-primary', { 'pi-angle-down ml-2': root, 'pi-angle-right ml-auto': !root }])
                    }, null, 2))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1040, ["to"])), [
              [_directive_ripple]
            ])
          ]),
          _: 1
        }, 8, ["model"])
      ]))
    : _withDirectives((_openBlock(), _createBlock(_component_router_link, {
        key: 1,
        to: _ctx.menu.to || '',
        class: "flex align-items-center mr-3",
        style: {"color":"black"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_font_awesome_icon, {
            icon: _ctx.menu.icon
          }, null, 8, ["icon"]),
          _createElementVNode("span", _hoisted_5, [
            _createTextVNode(_toDisplayString(_ctx.menu.label) + " ", 1),
            (_ctx.menu.badge)
              ? (_openBlock(), _createBlock(_component_p_badge, {
                  key: 0,
                  class: "ml-auto",
                  value: _ctx.menu.badge
                }, null, 8, ["value"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["to"])), [
        [_directive_ripple]
      ])
}